document.addEventListener("DOMContentLoaded", function () {

  function waitCartAndInit() {

    const cart = document.querySelector(".xb_slidecart");
    if (!cart) return;

    initCartUX(cart);
  }

  function initCartUX(cart) {

    if (cart.classList.contains("ux-loaded")) return;
    cart.classList.add("ux-loaded");

    const wrapper = document.querySelector(".xboost-cart-slide-vt");
    const overlay = document.querySelector(".xb-cart-drawer-wrapper");
    const closeBtn = document.querySelector(".xb_slide_cart_close_button");

    /* ===== CUPOM ===== */
    const section = cart.querySelector(".xb_slide_cart_discount_section");
    const inputWrap = cart.querySelector(".xb_slide_cart_discount_code_input");

    if (section && inputWrap) {

      inputWrap.style.display = "";

      if (!section.querySelector(".coupon-title")) {

        const title = document.createElement("div");
        title.className = "coupon-title";
        title.innerText = "Tem um código promocional?";

        title.style.fontSize = "13px";
        title.style.cursor = "pointer";
        title.style.padding = "6px 0";

        section.prepend(title);
        section.classList.remove("active");

        title.onclick = () => {
          section.classList.toggle("active");
        };
      }
    }

    /* ===== BOTÕES ===== */
    if (!cart.querySelector(".side-cart-actions")) {

      const actions = document.createElement("div");
      actions.className = "side-cart-actions hide-3d";

      actions.innerHTML = `
        <button class="side-cart-back">Voltar</button>
        <button class="side-cart-checkout">Finalizar</button>
      `;

      cart.appendChild(actions);

      actions.querySelector(".side-cart-back").onclick = () => {
        closeCartSmooth();
      };

      actions.querySelector(".side-cart-checkout").onclick = () => {
        window.location.href = "/checkout";
      };
    }

    const actions = cart.querySelector(".side-cart-actions");

    /* ===== TOTAL ===== */
function updateTotal() {

  const footer = cart.querySelector(".xb_slide_cart_footer");
  const economiaBox = cart.querySelector(".xb_slide_cart_footer_total_saving");

  let totalRow = cart.querySelector(".custom-total-row");

  if (!totalRow && footer) {

    totalRow = document.createElement("div");
    totalRow.className = "custom-total-row";

    totalRow.style.display = "flex";
    totalRow.style.justifyContent = "space-between";
    totalRow.style.marginTop = "6px";
    totalRow.style.fontSize = "13px";
    totalRow.style.color = "#000";

    if (economiaBox) {
      economiaBox.insertAdjacentElement("afterend", totalRow);
    } else {
      footer.appendChild(totalRow);
    }
  }

  const hasItems =
    cart.querySelectorAll(".xb_slide_cart_product").length > 0;

  if (!totalRow)
    return;

  if (!hasItems) {
    totalRow.style.display = "none";
    return;
  }

  /* procura o total REAL do carrinho */
const totalElement =
    cart.querySelector(".xb_slide_cart_footer_total_price") ||
    cart.querySelector(".xb_slide_cart_total_price") ||
    cart.querySelector("[data-cart-total]") ||
    cart.querySelector(".xb_slide_cart_button_checkout span span");

if (!totalElement)
    return;

let total = totalElement.textContent.trim();

/* remove o texto do botão */
total = total
    .replace(/Finalizar compra\s*[•·-]?\s*/i, "")
    .trim();

  if (!totalElement)
    return;

  totalRow.style.display = "flex";

  totalRow.innerHTML = `
      <span>Preço total</span>
      <span style="font-weight:600">${total}</span>
  `;
}

    /* ===== ATUALIZAÇÃO GERAL ===== */
    function updateCartState() {

      const products = cart.querySelectorAll(".xb_slide_cart_product");
      const hasItems = products.length > 0;

      /* BOTÕES */
      if (actions) {

        if (hasItems) {

          actions.style.display = "grid";

          requestAnimationFrame(() => {
            actions.classList.remove("hide-3d");
          });

        } else {

          actions.classList.add("hide-3d");

          setTimeout(() => {
            if (!cart.querySelector(".xb_slide_cart_product")) {
              actions.style.display = "none";
            }
          }, 300);
        }
      }

      /* ===== EMPTY CART ANIMAÇÃO ===== */
      const emptyCart = cart.querySelector(".xb_slide_cart_empty_cart_title")?.closest(".xb-flex-1");

      if (emptyCart) {

        emptyCart.classList.add("empty-cart-ux");

        if (hasItems) {

          emptyCart.classList.add("hide-3d");

          setTimeout(() => {
            if (cart.querySelector(".xb_slide_cart_product")) {
              emptyCart.style.display = "none";
            }
          }, 450);

        } else {

          emptyCart.style.display = "flex";

          requestAnimationFrame(() => {
            emptyCart.classList.remove("hide-3d");
          });
        }
      }

      updateTotal();
    }

    updateCartState();

    /* ===== OBSERVER ===== */
    let lastCount = cart.querySelectorAll(".xb_slide_cart_product").length;

let updateTimer;

const observer = new MutationObserver(() => {

    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {
        updateCartState();
    }, 80);

});

    observer.observe(cart, {
      childList: true,
      subtree: true
    });

    function closeCartSmooth() {
      if (!wrapper || !closeBtn) return;

      closeBtn.click();

      requestAnimationFrame(() => {
        wrapper.style.transform = "translateX(100%)";
        if (overlay) overlay.style.opacity = "0";
      });

      setTimeout(() => {
        wrapper.style.transform = "";
        if (overlay) overlay.style.opacity = "";
      }, 300);
    }

    if (overlay && !overlay.classList.contains("ux-overlay-ready")) {
      overlay.classList.add("ux-overlay-ready");

      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) {
          closeCartSmooth();
        }
      });
    }

    if (closeBtn && !closeBtn.classList.contains("ux-close-ready")) {
      closeBtn.classList.add("ux-close-ready");

      closeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        closeCartSmooth();
      });
    }
  }

  let tries = 0;
  const interval = setInterval(() => {
    waitCartAndInit();
    tries++;
    if (tries > 40) clearInterval(interval);
  }, 250);

});